export const TEXTS = {
  // Shared across multiple components
  "common.app-name": { en: "Frenky Football!", it: "Frenky Football!" },
  "common.change-parameters": {
    en: "Change parameters",
    it: "Cambia parametri",
  },
  "common.loading": { en: "Loading...", it: "Caricamento..." },
  "common.back-to-form": { en: "Back to form", it: "Torna alla selezione" },
  "common.loading-section": { en: "Loading", it: "Caricamento" },
  "common.unable-to-load-section": {
    en: "Unable to load",
    it: "Impossibile caricare",
  },
  "common.fetching-player": {
    en: "Fetching player data...",
    it: "Recupero dati del giocatore...",
  },
  "common.error-missing-player": {
    en: "This link is missing player details.",
    it: "Questo link non contiene i dettagli del giocatore.",
  },
  "common.error-load-player": {
    en: "Unable to load that player right now.",
    it: "Impossibile caricare il giocatore al momento.",
  },
  "common.share-unsupported": {
    en: "Sharing is not supported on this device.",
    it: "La condivisione non è supportata su questo dispositivo.",
  },
  "common.share-error": {
    en: "Unable to share right now.",
    it: "Impossibile condividere al momento.",
  },
  "common.player-portrait-alt": {
    en: "Player portrait",
    it: "Foto del giocatore",
  },
  "common.player-portrait-suffix": { en: "portrait", it: "foto" },
  "common.birth-year": { en: "Birth year", it: "Anno di nascita" },
  "common.nationality": { en: "Nationality", it: "Nazionalità" },
  "common.position": { en: "Position", it: "Ruolo" },
  "common.unknown": { en: "Unknown", it: "Sconosciuto" },
  "common.challenge-friend": { en: "Challenge a friend", it: "Sfida un amico" },

  // FormView
  "form.mode-career-short": { en: "Career", it: "Carriera" },
  "form.mode-career": {
    en: "Guess a player by his career",
    it: "Indovina il giocatore dalla sua carriera",
  },
  "form.mode-photo-short": { en: "Photo", it: "Foto" },
  "form.mode-photo": {
    en: "Guess a player by his photo",
    it: "Indovina il giocatore dalla sua foto",
  },
  "form.mode-stats-short": { en: "1-Year Stats", it: "Stagione" },
  "form.mode-stats": {
    en: "Guess a player by his 1-year stats",
    it: "Indovina il giocatore dalle sue statistiche in una singola stagione",
  },
  "form.league-label": { en: "League", it: "Campionato" },
  "form.club-label": { en: "Club", it: "Squadra" },
  "form.season-label": { en: "Season", it: "Stagione" },
  "form.random-option": { en: "(Random)", it: "(Casuale)" },
  "form.difficulty-label": { en: "Difficulty", it: "Difficoltà" },
  "form.difficulty-easy": { en: "Easy", it: "Facile" },
  "form.difficulty-medium": { en: "Medium", it: "Medio" },
  "form.difficulty-hard": { en: "Hard", it: "Difficile" },
  "form.difficulty-games-suffix": { en: "games", it: "partite" },
  "form.button-play": { en: "Play", it: "Gioca" },
  "form.error-load-player": {
    en: "Unable to load a player for that selection.",
    it: "Impossibile caricare un giocatore per la selezione effettuata.",
  },

  // PlayerInfo
  "player-info.button-show": { en: "Show", it: "Mostra" },

  // PlayerGuessBox
  "guess-box.label": { en: "Guess", it: "Indovina" },
  "guess-box.placeholder": {
    en: "Type the player name",
    it: "Scrivi il nome del giocatore",
  },
  "guess-box.button-check": { en: "Check", it: "Verifica" },
  "guess-box.button-hint": { en: "Hint", it: "Suggerimento" },
  "guess-box.button-skip": { en: "I don't know", it: "Non lo so" },
  "guess-box.error-empty": {
    en: "Type a name before checking.",
    it: "Scrivi un nome prima di verificare.",
  },
  "guess-box.error-wrong": {
    en: "Wrong answer, try again.",
    it: "Risposta errata, riprova.",
  },

  // PlayerShareBox
  "share-box.label": { en: "Share", it: "Condividi" },
  "share-box.button": { en: "Share the player", it: "Condividi il giocatore" },

  // PlayerCareerTable
  "career-table.header-season": { en: "Season", it: "Stagione" },
  "career-table.header-club": { en: "Club", it: "Club" },
  "career-table.header-games-goals": {
    en: "Games (Goals)",
    it: "Partite (Gol)",
  },
  "career-table.aggregate-label": {
    en: "Aggregate the seasons with the same club",
    it: "Raggruppa le stagioni con lo stesso club",
  },

  // PlayerSeasonData
  "season-data.loading": {
    en: "Loading season stats...",
    it: "Caricamento statistiche stagionali...",
  },
  "season-data.empty": {
    en: "No season stats available.",
    it: "Nessuna statistica stagionale disponibile.",
  },
  "season-data.show-extra": { en: "Show extra data", it: "Mostra altri dati" },
  "season-data.error-missing": {
    en: "Season details are missing for this player.",
    it: "I dettagli della stagione non sono disponibili per questo giocatore.",
  },
  "season-data.error-no-stats": {
    en: "No stats available for that season.",
    it: "Nessuna statistica disponibile per questa stagione.",
  },
  "season-data.error-load": {
    en: "Unable to load season stats right now.",
    it: "Impossibile caricare le statistiche stagionali al momento.",
  },
  "season-data.stat-leagues": { en: "Leagues", it: "Campionati" },
  "season-data.stat-league": { en: "League", it: "Campionato" },
  "season-data.stat-season": { en: "Season", it: "Stagione" },
  "season-data.stat-clubs": { en: "Clubs", it: "Club" },
  "season-data.stat-club": { en: "Club", it: "Club" },
  "season-data.stat-games": { en: "Games", it: "Partite" },
  "season-data.stat-goals": { en: "Goals", it: "Gol" },
  "season-data.stat-goals-conceded": { en: "Goals Conceded", it: "Gol Subiti" },
  "season-data.stat-assists": { en: "Assists", it: "Assist" },
  "season-data.stat-cards": { en: "Cards", it: "Cartellini" },
  "season-data.stat-shots": { en: "Shots", it: "Tiri" },
  "season-data.stat-passes": { en: "Passes", it: "Passaggi" },
  "season-data.stat-fouls": { en: "Fouls", it: "Falli" },
  "season-data.stat-duels": { en: "Duels", it: "Duelli" },
  "season-data.stat-tackles": { en: "Tackles", it: "Contrasti" },
  "season-data.stat-dribbles": { en: "Dribbles", it: "Dribbling" },
  "season-data.sub-total": { en: "total", it: "totale" },
  "season-data.sub-lineups": { en: "lineups", it: "titolare" },
  "season-data.sub-min": { en: "min", it: "min" },
  "season-data.sub-yellow": { en: "yellow", it: "gialli" },
  "season-data.sub-red": { en: "red", it: "rossi" },
  "season-data.sub-on": { en: "on", it: "in porta" },
  "season-data.sub-key": { en: "key", it: "chiave" },
  "season-data.sub-accuracy": { en: "accuracy", it: "precisione" },
  "season-data.sub-committed": { en: "committed", it: "commessi" },
  "season-data.sub-drawn": { en: "drawn", it: "pareggiati" },
  "season-data.sub-won": { en: "won", it: "vinti" },
  "season-data.sub-attempts": { en: "attempts", it: "tentativi" },
  "season-data.sub-success": { en: "success", it: "riusciti" },

  // CareerView
  "career-view.label": { en: "Player Data", it: "Dati del giocatore" },
  "career-view.fetching": {
    en: "Fetching career stats...",
    it: "Recupero statistiche di carriera...",
  },

  // PhotoView
  "photo-view.label": { en: "Player Photo", it: "Foto del giocatore" },
  "photo-view.fetching": {
    en: "Fetching player photo...",
    it: "Recupero foto del giocatore...",
  },

  // OneYearView
  "one-year-view.label": {
    en: "One Season Stats",
    it: "Statistiche in una stagione",
  },
  "one-year-view.fetching": {
    en: "Fetching season stats...",
    it: "Recupero statistiche stagionali...",
  },
  "one-year-view.error-missing-season": {
    en: "This link is missing season details.",
    it: "Questo link non contiene i dettagli della stagione.",
  },

  // WinView
  "win-view.heading": { en: "You won!", it: "Hai vinto!" },
  "win-view.button-play-again": { en: "Play again", it: "Gioca ancora" },

  // LoseView
  "lose-view.heading": { en: "Not this time!", it: "Non questa volta!" },
  "lose-view.button-retry": { en: "Retry", it: "Riprova" },

  // Game store error messages
  "store.invalid-league-season": {
    en: "Please select a valid league and season.",
    it: "Seleziona un campionato e una stagione validi.",
  },
  "store.no-season-history": {
    en: "No season history available for that player.",
    it: "Nessuna stagione disponibile per questo giocatore.",
  },
  "store.no-career-stats": {
    en: "No career stats available for that player. Please try again.",
    it: "Nessuna statistica di carriera disponibile per questo giocatore. Riprova.",
  },
  "store.no-career-stats-short": {
    en: "No career stats available for that player.",
    it: "Nessuna statistica di carriera disponibile per questo giocatore.",
  },
  "store.something-went-wrong": {
    en: "Something went wrong. Please try again.",
    it: "Qualcosa è andato storto. Riprova.",
  },
  "store.no-eligible-stats": {
    en: "No eligible stats found for that player.",
    it: "Nessuna statistica valida trovata per questo giocatore.",
  },
  "store.missing-player-details": {
    en: "Player details are missing for that entry.",
    it: "I dettagli del giocatore non sono disponibili per questo elemento.",
  },
  "store.no-players-found": {
    en: "No players found for that league and season. Try another selection.",
    it: "Nessun giocatore trovato per questo campionato e questa stagione. Prova un'altra selezione.",
  },

  // API service error messages
  "api.missing-key": {
    en: "Missing API key. Add VITE_API_FOOTBALL_KEY to your .env file.",
    it: "Chiave API mancante. Aggiungi VITE_API_FOOTBALL_KEY nel file .env.",
  },
  "api.request-failed": {
    en: "API request failed",
    it: "Richiesta API fallita",
  },
  "api.error": {
    en: "API error. Please try again later.",
    it: "Errore API. Riprova più tardi.",
  },
};
